// Game settings → Audit (spec/dashboard.md section 12.4): `GET …/games/{game}/audit` with the URL filters (`read_audit`);
// the M7 filters (spec/api-conventions.md section 21.1) user, branch (a select of the game's branch names) and environment
// (dev | stage | prod); `?entry=<id>` reads one row through `GET …/audit/{entry}`.
import { ops } from '../../api/operations';
import type { AuditEntry, Page } from '../../api/types';
import { useAuth } from '../../auth/AuthContext';
import { useGame } from '../../shell/GameContext';
import { formatInstantWithZone, useTimeZone } from '../../ui/time';
import { AuditPanel } from './AuditPanel';
import { AUDIT_PAGE_SIZE, ENVIRONMENT_KINDS } from './keys';
import { Lock } from '../../ui/icons';

export function AuditTab() {
  const { org, game, environments, branches, can, offsets } = useGame();
  const { client } = useAuth();
  const [zone] = useTimeZone();
  if (!can('read_audit')) {
    return (
      <div data-testid="settings-audit">
        <div className="pane">
          <div className="pane-body">
            <p className="muted settings-locked" role="note">
              <Lock className="icon-s" aria-hidden="true" /> You lack the 'read_audit' permission.
            </p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div data-testid="settings-audit">
      <AuditPanel
        cacheKey={`game:${org}/${game.slug}:audit`}
        fetchPage={(filters, cursor) => client.data(ops.listGameAudit, { path: { org, game: game.slug }, query: { ...filters, limit: AUDIT_PAGE_SIZE, ...(cursor ? { cursor } : {}) } }) as unknown as Promise<Page<AuditEntry>>}
        fetchEntry={(entry) => client.data(ops.getGameAuditEntry, { path: { org, game: game.slug, entry } })}
        branches={branches.map((b) => b.name)}
        environments={ENVIRONMENT_KINDS}
        when={(v) => formatInstantWithZone(v, zone, { offsets })}
        ctx={{ offsets }}
        envLabel={(id) => environments.find((e) => e.id === id)?.slug ?? id}
        branchLabel={(id) => branches.find((b) => b.id === id)?.name ?? id}
      />
    </div>
  );
}
